import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

Vue.use(Vuex)

const state = {

	settings: JSON.parse(localStorage.getItem('shiseido-settings')) || {},
	token: localStorage.getItem('shiseido-token') || null,

	// shiseido db options
	options: {
		area: [],
		brand: [],
		country: [],
		distributionChannel: [],
		generalFloorPlan: [],
		groupeSpacePlan: [],
		projectStatus: [],
		speficifNeed: [],
		typeOfProjectLabel: [],
		typeOfStore: [],
		csrf_new_token: '',
	},

	optionsLoaded: false,

	// shiseido db of projects
	projects: {},
	indexes: [],
	projectsFile: '',

	// persistent filters for dashboard
	filters: JSON.parse(sessionStorage.getItem('shiseido-filters')) || {
		id: '',
		search: '',
		year: [],
		age: [],
		brand: [],
		typeOfProjectLabel: [],
		typeOfProjectType: [],
		distributionChannel: [],
		area: [],
		country: '',
		city: '',
		retailer: '',
		storeName: '',
		typeOfStore: '',
		storeLevel: '',
		beautyConsultant: [],
		totalCost: [],
		annualTurnover: [],
		sqm: [],
		costPerSqm: [],
		supplier: '',
		openRefurbish: '',
		personalizationType: '',
		furnitureType: '',
		dateOfRequest: [],
		projectStatus: [3], // Default to "On Going"
		installationDate: [],
		posClosedDate: []
	}
}

const store = new Vuex.Store({
	state,
	getters,
	actions,
	mutations
})

// hot reload
if (module.hot) {
	module.hot.accept([
		'./getters',
		'./actions',
		'./mutations'
	], () => {
		store.hotUpdate({
			getters: require('./getters'),
			actions: require('./actions'),
			mutations: require('./mutations')
		})
	})
}

export default store



// WEBPACK FOOTER //
// ./src/store/index.js